export const validation = () => {
  const required = 'Заповніть це поле'

  const phoneValid = 'Невірний формат телефону'

  return {
    required,
    phoneValid,
  }
}
